import axios, { AxiosError } from 'axios';

export const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    const status = err.response?.status;
    const url = err.config?.url ?? '';
    const isProbe = url.includes('/auth/me');
    if (status === 401 && !isProbe && typeof window !== 'undefined') {
      window.location.assign('/api/auth/login');
    }
    return Promise.reject(err);
  },
);
